import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Typography } from '@mui/material';
import { FC, useCallback } from 'react';
import _ from 'lodash';
import { renderWithRequiredIndicator } from '../../../../../../util';
import { SmartValueListItem } from './SmartValueSlice';

export interface IEditStepRequestDataInputProps {
    errorMessage?: string;
    dataOptions: SmartValueListItem[];
    selectedDataOptions: string[];
    updateSelectedDataOptions: (updatedData: string[]) => void;
}

export const EditStepRequestDataInput: FC<IEditStepRequestDataInputProps> = props => {
    const { errorMessage, dataOptions, selectedDataOptions, updateSelectedDataOptions } = props;

    const isChecked = useCallback((value: string) => {
        return selectedDataOptions.includes(value);
    }, [selectedDataOptions]);

    const toggleLabelSelected = useCallback((value: string) => {
        var updatedSelectedOptions = _.cloneDeep(selectedDataOptions);
        var isSelected = isChecked(value);
        if (isSelected) {
            updatedSelectedOptions = updatedSelectedOptions.filter(selectedOption => selectedOption !== value);
        } else {
            updatedSelectedOptions.push(value);
        }
        updateSelectedDataOptions(updatedSelectedOptions);
    }, [isChecked, selectedDataOptions, updateSelectedDataOptions]);

    return (
        <Grid item xs={12}>
            <FormControl error={!!errorMessage} fullWidth>
                <FormLabel>Request Data</FormLabel>
                <Grid item xs={12} container direction='column' border='1px solid #c4c4c4' p={1} borderRadius={1}>
                    {dataOptions.length === 0 && (
                        <Grid item>
                            <Typography>No data collected so far</Typography>
                        </Grid>
                    )}
                    {dataOptions.map((requestDataOption, i) => (
                        <Grid item key={`request-data-option-${i}`}>
                            <FormControlLabel control={<Checkbox checked={isChecked(requestDataOption.value ?? '')} onClick={() => toggleLabelSelected(requestDataOption.value ?? '')} />} label={renderWithRequiredIndicator(requestDataOption.value ?? '', requestDataOption.metadata.isRequired)} />
                        </Grid>
                    ))}
                </Grid>
                <FormHelperText>{errorMessage}</FormHelperText>
            </FormControl>
        </Grid>
    )
}